import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { query, collection, orderBy } from 'firebase/firestore';

export default function useParksById() {

  const firestore = useFirestore();
  const parksCollection = collection(firestore, 'parks');
  const parksQuery = query(parksCollection, orderBy('name', 'asc'));
  const { data: parks } = useFirestoreCollectionData(parksQuery);

  return parks ? parks.reduce((acc, park) => {
    acc[park['NO_ID_FIELD']] = park;
    return acc;
  }, {}) : {};

}
